<template>
  <a :href="href">
    {{ text }}
  </a>
</template>
<script lang="ts">
export default { name: 'LoginLink' }
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useUserStore } from '~/store/user'
import { appUrl } from '~/lib/url'

const props = withDefaults(
  defineProps<{
    loggedInText?: string
    loggedInAction?: string
    loggedOutText?: string
    loggedOutAction?: string
  }>(),
  {
    loggedInText: 'Dashboard',
    loggedInAction: 'dashboard',
    loggedOutText: 'Log In',
    loggedOutAction: 'signin',
  },
)

const userStore = useUserStore()
const { isLoggedInUser } = storeToRefs(userStore)

const href = computed(() => isLoggedInUser.value ? appUrl(props.loggedInAction) : appUrl(props.loggedOutAction))
const text = computed(() => isLoggedInUser.value ? props.loggedInText : props.loggedOutText)

</script>
